<template>
    <ScreenLayout title="Taco Billing" ref="screenLayout" :right-visible="false">
    <v-toolbar slot="header" dark dense class="primary no-print">
        <v-btn @click.native="$router.push('/home')" icon>
            <v-icon>home</v-icon>
        </v-btn>
        <v-toolbar-title>Taco Billing</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip left>
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" dark icon @click="showingSummary = !showingSummary">
                <v-icon>list</v-icon>
            </v-btn>
            </template>
            <span>Show Summary</span>
        </v-tooltip>

        <v-tooltip left>
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" dark icon @click="mine = !mine; loadInvoices()">
                <v-icon>account_circle</v-icon>
            </v-btn>
            </template>
            <span>Invoices to Me</span>
        </v-tooltip>

        <v-tooltip left>
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" dark icon @click="loadInvoices">
                <v-icon>refresh</v-icon>
            </v-btn>
            </template>
            <span>Refresh List</span>
        </v-tooltip>

    </v-toolbar>

        <template slot="left">
            <div class="pa-2 lighten-1 ma-2" :class="{green: isLastMonth(month), red: !isLastMonth(month)}" style="border-radius:30px">
                <div class="display-flex full-width">
                    <v-btn color="white" @click="decrementMonth" icon>
                        <v-icon>mdi-arrow-left-circle-outline</v-icon>
                    </v-btn>
                    <div class="heading center-text mt-1" style="flex-grow:1;color:#fff">{{monthFormatted}}</div>
                    <v-btn color="white" @click="incrementMonth(1)" icon>
                        <v-icon>mdi-arrow-right-circle-outline</v-icon>
                    </v-btn>
                </div>
            </div>

            <div v-if="grandTotal !== 0" class="pa-4 rounded white ma-3 center-text">
                <div class="display-flex">
                    <div class="pa-1 flex-col-sm" style="font-size:32px;margin-top:-6px">
                        {{grandTotal|currency}}
                    </div>
                    <div class="element-label pa-1 uppercase" style="text-align:left">
                        total for month
                    </div>
                </div>
            </div>

            <template v-if="isAdministrator && viewingPreviousMonth">
                <div  v-if="invoicesNeedingValidation.length" class="pa-4 rounded white ma-3 center-text">
                    <div class="display-flex">
                        <div class="pa-1 flex-col-sm" style="font-size:32px;margin-top:-6px">
                            {{invoicesNeedingValidation.length}}
                        </div>
                        <div class="element-label pa-1 uppercase" style="text-align:left">
                            invoices needing validation
                        </div>
                    </div>
                    <v-btn @click="requestValidationMultiple" rounded color="primary" style="min-width:100px">Request</v-btn>
                </div>
                <div  v-if="invoicesReadyToSend.length" class="pa-4 rounded white ma-3 center-text">
                    <div class="display-flex">
                        <div class="pa-1 flex-col-sm" style="font-size:32px;margin-top:-6px">
                            {{invoicesReadyToSend.length}}
                        </div>
                        <div class="element-label pa-1 uppercase" style="text-align:left">
                            invoices ready to send
                        </div>
                    </div>
                    <!-- Disable for now to send individually -->
                    <!-- <v-btn @click="sendInvoiceMultiple" rounded color="primary" style="min-width:100px">Send</v-btn> -->
                </div>
                <div  v-if="processorsReadyToMakeLength" class="pa-4 rounded white ma-3 center-text">
                    <div class="display-flex">
                        <div class="pa-1 flex-col-sm" style="font-size:32px;margin-top:-6px">
                            {{processorsReadyToMakeLength}}
                        </div>
                        <div class="element-label pa-1 uppercase" style="text-align:left">
                            processors ready to invoice
                        </div>
                    </div>
                    <v-btn @click="makeInvoiceMultiple" rounded color="primary" style="min-width:100px">Make Invoices</v-btn>
                </div>
                <div  v-if="insightInvoicesAllSent" class="pa-4 rounded white ma-3 center-text">
                    <div class="display-flex">
                        <div class="pa-1 flex-col-sm" style="font-size:32px;margin-top:-6px">
                            {{insightInvoicesPaid.length}}
                        </div>
                        <div class="element-label pa-1 uppercase" style="text-align:left">
                            insight invoices paid out of {{insightInvoices.length}}
                        </div>
                    </div>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                            <v-btn v-on="on" @click="emailAllInvoicesToBookkeeper" rounded color="primary" style="min-width:100px">Bookkeeper</v-btn>
                      </template>
                      <span>Email Invoices to Bookkeeper</span>
                    </v-tooltip>
                </div>
                <div class="pa-4 rounded white ma-3 center-text">
                    <div class="display-flex">
                        <div class="pa-1 flex-col-sm" style="font-size:32px;margin-top:-6px">
                            {{invoicesPaid.length}}
                        </div>
                        <div class="element-label pa-1 uppercase" style="text-align:left">
                            insight invoices paid out of {{invoices.length}}
                        </div>
                    </div>
                </div>
            </template>

        </template>

        <!-- Invoices -->

        <NoRecordsPlaceholder v-if="!invoices.length" :delay="2000">
                No Invoices
        </NoRecordsPlaceholder>

        <!-- Summary -->

        <div v-if="showingSummary" class="white pa-5 rounded ma-3">
            <div v-for="(sender, index) in invoicesBySender" class="mt-3" :key="index">
                <div class="heading">{{sender.from | fullName}}</div>
                <div v-for="(invoice, formIndex) in sender.invoices" :key="formIndex">
                    <v-icon>mdi-checkbox-blank-outline</v-icon>
                    {{invoice.to | fullName}} {{invoice.total * 1.1 | cents}} (incl gst)
                    <span class="light-text">({{getInvoiceId(invoice)}})</span>
                    <span v-if="invoiceHasTag(invoice, 'paid')"> *** PAID ***</span>

                </div>
            </div>
        </div>


        <template v-if="!showingSummary">

        <div v-for="(sender, index) in invoicesBySender" class="elevation-1 white rounded ma-3 pa-3 no-print-border" :key="index" style="max-width: 800px">
            <div class="display-flex no-print">

                <v-avatar size="60" class="mr-2">
                    <img :src="sender.from.image"/>
                </v-avatar>
                <div class="flex-col-grow">
                    <div class="heading">{{sender.from | fullName}}</div>
                    <v-btn v-if="senderNeedsInvoicing(sender)" color="orange lighten-3" @click="makeInvoiceSingle(sender)" depressed rounded class="mb-2">
                        Create Processor Invoice
                    </v-btn>
                </div>
                <div style="font-size:30px" class="blue--text">
                    {{sender.consultantTotal|currency}}
                    <div class="element-label center-text full-width text-uppercase" style="margin-top:-5px">{{sender.invoices.length}} Invoice/s</div>
                </div>
            </div>

            <div class="grey lighten-4 pa-2 rounded">
                <div v-for="(invoice) in sender.invoices" class="white rounded ma-2 pa-3" :key="invoice.meta.key">

                    <div class="display-flex no-print">

                        <div class="flex-col-grow">
                        <div class="heading mb-2">
                            {{invoice.to | fullName}}
                            <v-menu v-if="!mine" offset-y>
                                <template v-slot:activator="{ on }">
                                <v-icon v-on="on">keyboard_arrow_down</v-icon>
                                </template>
                                <v-list>
                                    <v-list-item @click="showCharge(invoice)">
                                        <v-list-item-title>Add Charge for {{invoice.to.firstName}}</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="resetInvoice(invoice)">
                                        <v-list-item-title>Reset Workflow</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="populateEntities(invoice)">
                                        <v-list-item-title>Populate Entities</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="isAdministrator" @click="debugInvoice(invoice)">
                                        <v-list-item-title>Debug Invoice</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="emailMe(invoice)">
                                        <v-list-item-title>Email Invoice to Me</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="openInvoice(invoice)">
                                        <v-list-item-title>Open in New Window</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>

                        <StatusLine v-model="invoice.tags" :available-stages="billingStagesVisible"/>

                        </div>
                        <div style="padding-top:20px">

                            <div xxstyle="border:solid 4px #ccc;padding:8px;border-radius:10px;">
                                <!-- <div class="element-label uppercase center-text">{{invoice.charges.length}} Charges</div> -->
                                <div class="heading center-text" style="padding-top:18px;margin-left:8px">{{invoice.total * 1.1 | cents}}</div>
                            </div>
                        </div>
                    </div>

                    <!-- Buttons -->

                    <div class="pa-2 no-print">
                        <v-btn v-if="(!isInvoiceReadyToSend(invoice) && (!invoice.meta.preview) ) || !viewingPreviousMonth" @click="previewInvoice(invoice)" depressed rounded>
                            Preview {{invoice.charges.length}} Charges
                        </v-btn>
                        <template v-if="viewingPreviousMonth && !mine">
                            <v-btn v-if="isAdministrator && !invoiceHasTag(invoice, 'validation requested')" color="blue lighten-3" @click="requestValidation(invoice)" depressed rounded>
                                Request Validation
                            </v-btn>
                            <v-btn v-if="!invoiceHasTag(invoice, 'valid')" color="blue lighten-3" @click="validate(invoice)" depressed rounded>
                                Validate
                            </v-btn>
                            <v-btn v-if="isInvoiceReadyToSend(invoice)" color="primary" @click="previewInvoice(invoice)" depressed rounded>
                                Ready To Send
                            </v-btn>

                            <template v-if="invoiceHasTag(invoice, 'sent') && !invoiceHasTag(invoice, 'paid')">
                                <!-- <v-btn color="orange lighten-3" @click="sendReminder(invoice)" depressed rounded>
                                    {{reminderText(invoice)}}
                                </v-btn>                         -->
                                <v-btn color="blue lighten-3" @click="markPaid(invoice)" depressed rounded>
                                    Payment Received
                                </v-btn>
                            </template>
                        </template>
                        <v-btn v-if="invoice.total === 0 && !mine" dark color="red darken-1" @click="deleteInvoice(invoice)" depressed rounded>
                            Delete Invoice
                        </v-btn>
                        <div class="orange--text small-text" v-if="isInvoiceReadyToMake(invoice)">Ready to Make</div>
                    </div>

                    <!-- Invoice Preview -->

                    <!-- <div :class="{'invoice-print-only': !invoice.meta.preview}" class="invoice"> -->
                    <v-expand-transition>
                    <div v-show="invoice.meta.preview" class="invoice">
                        <v-icon color="red lighten-3" class="no-print" @click="$set(invoice.meta, 'preview', false)" style="position:absolute;right:5px;top:5px;">
                            cancel
                        </v-icon>
                        <div style="padding:18px">

                            <Invoice  @delete-charge="deleteCharge" :invoice="invoice" :key="invoice.meta.key" />
<!-- :ref="invoice.meta.key" -->
                        </div>
                        <div v-if="!mine" class="center-text no-print pa-3">
                            <template v-if="invoiceHasTag(invoice, 'valid') && !invoiceHasTag(invoice, 'sent') && viewingPreviousMonth">
                                <v-btn class="no-print"  color="primary" @click="sendInvoice(invoice)" depressed rounded>
                                    Send Invoice
                                </v-btn>
                                <a class="ml-3 no-print"  color="primary" @click="skipSendInvoice(invoice)">
                                    I sent it previously
                                </a>
                            </template>
                            <v-btn class="no-print" v-if="invoiceHasTag(invoice, 'sent')" color="primary" @click="sendInvoice(invoice)" depressed rounded>
                                Resend Invoice
                            </v-btn>
                        </div>
                    </div>
                    </v-expand-transition>
                </div>
            </div>

        </div>
        </template>

        <template slot="right">
        </template>

        <ChargeDialog v-if="chargeDialog.settings.visible" :settings="chargeDialog.settings" :charge="chargeDialog.charge" @saved="loadInvoices" />

    </ScreenLayout>
</template>

<script>
import {getDate, getMonth, getYear, format, addMonths, lastDayOfMonth, endOfMonth} from 'date-fns'
import LayoutContainer2 from '@/ui-elements/LayoutContainer2'
import SectionLayout from '@/screens/SectionLayout'
import ElementLayout from '@/screens/ElementLayout'
import LayoutReadOnly from '@/ui-elements/LayoutReadOnly'
import StatusLine from '@/ui-elements/StatusLine'
import ElementMenu from '@/screens/ElementMenu'
import ScrollHelpers from '@/helpers/ScrollHelpers'
import ScreenLayout from '@/screens/ScreenLayout'
import PageLayout from '@/screens/PageLayout'
import VueJsonToCsv from 'vue-json-to-csv'

import DateRangeList from '@/ui-elements/DateRangeList'
import ScreenData from '@/screens/ScreenData'
import ScreenTable from '@/screens/ScreenTable'
import Utilities from '@/helpers/Utilities'
import StringHelpers from '@/helpers/StringHelpers'
import DataHelpers from '@/helpers/DataHelpers'
import LookupData from '@/helpers/LookupData'
import TemplateHelpers from '@/helpers/TemplateHelpers'
import ArrayHelpers from '@/helpers/ArrayHelpers'
import AlertHelpers from '@/helpers/AlertHelpers'
import MergeHelpers from '@/helpers/MergeHelpers'
import EmailHelpers from '@/helpers/EmailHelpers'
import SplitButton from '@/ui-elements/SplitButton'
import NoRecordsPlaceholder from '@/ui-elements/NoRecordsPlaceholder'
import ContactHelpers from '@/helpers/ContactHelpers'
import DateHelpers from '@/helpers/DateHelpers'
import NiceData from '@/data/NiceData'
import BillingHelpers from '@/helpers/BillingHelpers'
import TagStatusHelpers from '@/helpers/TagStatusHelpers'
import FirebaseHelpers from '@/helpers/FirebaseHelpers'
import OrderHelpers from '@/helpers/OrderHelpers'
import ChargeDialog from '@/ui-elements/ChargeDialog'

import Invoice from './Invoice'


class PageSection {
    constructor(section) {
        this.section = section
    }
    fieldByName(name) {
        return this.section.fields.find(o => o.name == name) || null
    }
}

export default {
    data() {
        return {
            user: {},
            invoices: [],
            charges: [],
            month: DateHelpers.yearMonth(),
            showingSummary: false,
            mine: false,
            chargeDialog: {
                settings: {
                    visible: false,
                },
                charge: {
                    amount: 0,
                    date: null,
                    from: null,
                    to: null,
                    clients: null,
                    description: null,
                }
            },
        }
    },
    components: {
        ScreenLayout,
        StatusLine,
        NoRecordsPlaceholder,
        ChargeDialog,
        Invoice,
    },

    props: {

    },

    computed: {

        currentUser() {
            return DataHelpers.getUser()
        },
        isAdministrator() {
            return DataHelpers.isAdministrator()
        },

        invoicesBySender() {
            let result = {}
            // let consultantTotal = 0
            this.invoices.forEach(invoice => {
                if(!result[invoice.from.key]) {
                    //new consultant
                    result[invoice.from.key] = {
                        invoices: [],
                        from: invoice.from,
                        consultantTotal: 0
                    }
                }
                if(invoice.charges && invoice.charges.length) {
                    const total = invoice.charges.reduce((a, b) => a + (b.amount || 0), 0)
                    this.$set(invoice, 'total', total )
                } else {
                    this.$set(invoice, 'total', 0)
                }

                result[invoice.from.key].consultantTotal = result[invoice.from.key].consultantTotal + invoice.total
                result[invoice.from.key].invoices.push(invoice)
            })
            return result
        },

        monthFormatted() {
            const dt = DateHelpers.backwardsToDate(this.month + '-01')
            return format(dt, 'MMM yyyy')
        },

        billingStages() {
            return BillingHelpers.stages
        },

        billingStagesVisible() {
            return this.billingStages.filter(o => o.visible)
        },

        invoicesNeedingValidation() {
            return TagStatusHelpers.itemsWithoutTag(this.invoices, 'valid')
        },

        invoicesReadyToSend() {
            let invoices = []
            this.invoices.forEach(invoice => {
                if(
                    this.invoiceHasTag(invoice, 'valid')
                    && !this.invoiceHasTag(invoice, 'sent')
                )
                    invoices.push(invoice)
            })
            return invoices
        },

        invoicesPaid() {
            return this.invoices.filter(o => o.tags.paid)
        },

        insightInvoices() {
            return this.invoices.filter(o => o.from.email == 'billing@insightprocessing.com.au')
        },

        insightInvoicesSent() {
            let invoices = []
            this.insightInvoices.forEach(invoice => {
                if( this.invoiceHasTag(invoice, 'sent') )
                    invoices.push(invoice)
            })
            return invoices
        },

        insightInvoicesPaid() {
            let invoices = []
            this.insightInvoices.forEach(invoice => {
                if( this.invoiceHasTag(invoice, 'paid') )
                    invoices.push(invoice)
            })
            return invoices
        },

        insightInvoicesAllSent() {
            return this.insightInvoices.length == this.insightInvoicesSent.length && (this.insightInvoices.length > 0)
        },

        processorsReadyToMake() {
            let processors = {...this.invoicesBySender}
            for(let prop in processors) {
                const processor = processors[prop]
                if(!this.senderNeedsInvoicing(processor))
                    delete processors[prop]
            }
            return processors
        },
        processorsReadyToMakeLength () {
            return Object.keys(this.processorsReadyToMake).length
        },


        grandTotal() {
            let total = 0
            for(let prop in this.invoicesBySender) {
                total += this.invoicesBySender[prop].consultantTotal || 0
            }
            return total
        },

        // nextTwentieth() {
        //     debugger
        //     let today = new Date()
        //     let day = getDate(today)
        //     let month = getMonth(today) + (day > 15 ? 1 : 0)
        //     let year = getYear(today)
        //     return year + '-' + month + '-20'
        // },
        viewingPreviousMonth() {
            const currentMonth = format(new Date(), 'yyyy-MM')
            return Boolean(this.month < currentMonth)
        },
        viewingCurrentMonth() {
            const currentMonth = format(new Date(), 'yyyy-MM')
            return Boolean(this.month == currentMonth)
        },

    },

    methods: {

        isProcessor(contact) {
            return Boolean(this.getProcessorForContact(contact).email)
        },
        openInvoice(invoice) {
            this.$router.push('/invoice/' + this.month + '/' + invoice.meta.key)
        },
        loadInvoices() {
            let ref = DataHelpers.getRootRef().child(`app/billing/${this.month}/invoices`)

            //only see your own invoices...
            if(this.mine)
                ref = ref.orderByChild('to/key').equalTo(this.$store.getters.user.uid)
            else if(!this.isAdministrator) {
                ref = ref.orderByChild('from/key').equalTo(this.$store.getters.user.uid)
            }
            console.log('fetching...', ref)
            NiceData.fetchItemsFromFirebase(ref).then(invoices => {
                //console.log('got ' + invoices.length )
                this.$set(this, 'invoices', invoices)
                this.invoices.forEach(invoice => {
                    this.$set(invoice, 'charges', [])
                    //load charges...
                    const chargeRef = DataHelpers.getRootRef().child(`app/billing/${this.month}/charges`)
                        .orderByChild('invoice').equalTo(invoice.meta.key)
                    NiceData.fetchItemsFromFirebase(chargeRef).then(charges => {
                        this.$set(invoice, 'charges', charges.sort(OrderHelpers.sortByDate))
                    })
                })
            })
        },

        previewInvoice(invoice) {
            if(!invoice.from.abn) {
                this.populateEntities(invoice)
            }
            this.$set(invoice.meta, 'preview', true)
        },

        debugInvoice(invoice) {
            FirebaseHelpers.viewInConsole(invoice.meta.path + '/' + invoice.meta.key)
        },

        debugCharge(charge) {
            FirebaseHelpers.viewInConsole(charge.meta.path + '/' + charge.meta.key)
        },

        async populateEntities(invoice) {

            const processorDetails = this.getProcessorForContact(invoice.from)

            this.$set(invoice.from, 'abn', processorDetails.abn || '')
            this.$set(invoice.from, 'address', processorDetails.address || '')
            this.$set(invoice.from, 'account', processorDetails.account || '')
            this.$set(invoice.from, 'entity', processorDetails.entity || '')
            this.$set(invoice.from, 'mobile', processorDetails.mobile || invoice.from.mobile || '')

            const billingPreferences = await DataHelpers.getPreferencesGroup(invoice.to.tenantKey, invoice.to.uid, 'billing')

            this.$set(invoice.to, 'entity', billingPreferences.entity || '')
            this.$set(invoice.to, 'email', billingPreferences.email || invoice.to.email)
            this.$set(invoice.to, 'directDebitRef', billingPreferences.directDebitRef || invoice.to.directDebitRef || '')

            //charges are kept in a separate tree...
            const newInvoice = {...invoice}
            newInvoice.charges = []
            delete newInvoice['total']

            NiceData.saveItem(newInvoice)
        },

        incrementMonth(number = 1) {
            const dt = DateHelpers.backwardsToDate(this.month + '-01')
            const nextMonth = addMonths(dt, number)
            this.month = DateHelpers.yearMonth(nextMonth)
        },

        isLastMonth(month) {
            const previousMonth = format(addMonths(new Date(), -1), 'MM')
            const activeMonth = month.split('-')[1]
            return previousMonth == activeMonth
        },

        decrementMonth() {
            this.incrementMonth(-1)
        },

        getInvoiceId(invoice) {
            let payer = invoice.to
            let initials = ContactHelpers.initials(payer) + payer.lastName[payer.lastName.length -1].toUpperCase()

            let recipient = invoice.from
            let recipientInitials = ContactHelpers.initials(recipient)


            return initials + recipientInitials + '-' + invoice.month.split('-')[1]
        },

        invoiceHasTag(invoice, tagName) {
            return TagStatusHelpers.tagExists(invoice.tags, tagName)
        },

        invoiceAddTag(invoice, tagName) {
            if(!invoice.tags)
                this.$set(invoice, 'tags', {})
            TagStatusHelpers.addTag(invoice.tags, tagName)
        },

        reminderText(invoice) {
            if(this.invoiceHasTag(invoice, 'reminder sent'))
                return 'Remind Again'
            else
                return 'Send Reminder'
        },

        getTemplate(name) {
            return new Promise( (resolve, reject) => {
                TemplateHelpers.fetchTemplate('global', name).then(template => {
                    if(!template)
                        AlertHelpers.showAlert('Template not found:' + name)
                    resolve(template)
                })
            })
        },

        async resetInvoice(invoice) {
            if(await this.$root.$confirm('Reset', `Are you sure you want to reset the status on this invoice?`, { color: 'red' }) == true) {
                invoice.tags = {
                    created: true,
                    'created-date': new Date()
                }
                BillingHelpers.saveInvoiceTags(invoice)
            }
        },

        senderNeedsInvoicing(sender) {
            //if(sender.email == 'matt.ireland.home@gmail.com')
            let needs = false
            sender.invoices.forEach(invoice => {
                if(this.isInvoiceReadyToMake(invoice))
                    needs = true
            })
            return needs
        },

        isInvoiceReadyToMake(invoice) {
            const valid = this.invoiceHasTag(invoice, 'valid')
            const unmade = !(this.invoiceHasTag(invoice, 'insight invoice made'))
            const isClientInvoice = !this.isProcessor(invoice.to)
            const result = (valid && unmade && isClientInvoice)
            //console.log('invoice from ' + invoice.from.firstName + ' to ' + invoice.to.firstName + ' ready to make returns ' + result, invoice, )
            //console.log ('valid', valid, 'unmade', unmade, 'clientinv', isClientInvoice)
            return result
        },

        isInvoiceReadyToSend(invoice) {
            return this.invoiceHasTag(invoice, 'valid') &&
            (!this.invoiceHasTag(invoice, 'sent'))
        },

        // Actions

        async requestValidation(invoice) {
            const template = await this.getTemplate('Request Invoice Validation')
            this.emailInvoice(template, invoice.html, invoice.from.firstName, invoice.from.email, null, invoice)
            this.invoiceAddTag(invoice, 'validation requested')
            BillingHelpers.saveInvoiceTags(invoice)
        },
        validate(invoice) {
            this.invoiceAddTag(invoice, 'valid')
            if(!invoice.tags.validation_requested)
                this.invoiceAddTag(invoice, 'validation requested')
            BillingHelpers.saveInvoiceTags(invoice)
            AlertHelpers.showAlert('Validated. Thank you')
        },
        makeInvoice(sender) {
            sender.invoices.forEach(invoice => {
                const customer = ContactHelpers.fullName(invoice.to)
                const customerRevenue = invoice.total
                const userParams = LookupData.processors().find(o => o.email == invoice.from.email) || {rate: .15, email: 'unknown', firstName: 'Unknown'}
                const amount = userParams.rate * customerRevenue

                const to = invoice.from
                const firstDay = DateHelpers.backwardsToDate(this.month + '-01')
                const lastDay = lastDayOfMonth(firstDay)
                const date = DateHelpers.dateToBackwards(lastDay)
                const from = {
                    key: 'insight-processing',
                    uid: 'insight-processing',
                    firstName: 'Insight',
                    lastName: 'Processing',
                    email: 'billing@insightprocessing.com.au',
                    image: 'https://i.imgur.com/BekZJi7.png'
                }
                const charge = {
                    to, from, date, amount,
                    description: 'Insight Comms on ' + StringHelpers.formatCurrency(customerRevenue),
                    clients: customer,
                    internal: true,
                }

                if(this.isProcessor(invoice.to)) {
                    charge.amount = 0
                    charge.description = 'Internal - no charge'
                }

                BillingHelpers.saveCharge(charge)
                this.invoiceAddTag(invoice, 'insight invoice made')
                BillingHelpers.saveInvoiceTags(invoice)
            })
            AlertHelpers.showAlert('Invoice created for ' + sender.firstName)
        },
        async sendInvoice(invoice) {
            const template = await this.getTemplate('Send Invoice')
            let cc = invoice.from.email

            //for insight recipients, send cc to emma
            if(cc == 'billing@insightprocessing.com.au')
                cc = 'accounting@insightprocessing.com.au'

            this.emailInvoice(template, invoice.html, invoice.to.firstName, invoice.to.email, cc, invoice)
            this.invoiceAddTag(invoice, 'sent')
            BillingHelpers.saveInvoiceTags(invoice)

        },

        skipSendInvoice(invoice) {
            this.invoiceAddTag(invoice, 'sent')
            BillingHelpers.saveInvoiceTags(invoice)
        },

        async emailMe(invoice) {

            const template = await this.getTemplate('Send Invoice')
            this.emailInvoice(template, invoice.html, this.currentUser.firstName, this.currentUser.email, null, invoice)
        },

        async sendReminder(invoice) {
            if(!invoice.from.abn || !invoice.from.account) {
                AlertHelpers.showAlert('Email Failed. Missing abn or account')
                return
            }
            const template = await this.getTemplate('Send Invoice Reminder')
            this.emailInvoice(template, invoice.html, invoice.to.firstName, invoice.to.email, invoice.from.email, invoice)
            this.invoiceAddTag(invoice, 'reminder sent')
            BillingHelpers.saveInvoiceTags(invoice)

        },
        markPaid(invoice) {
            this.invoiceAddTag(invoice, 'paid')
            BillingHelpers.saveInvoiceTags(invoice)

        },

        // Multiple Actions
        makeInvoiceMultiple() {
            this.processorsReadyToMake.forEach(processor => {
                this.makeInvoice(processor)
            })
            this.loadInvoices()
            AlertHelpers.showAlert('Made invoices')
        },

        makeInvoiceSingle(sender) {
            this.makeInvoice(sender)
            this.loadInvoices()
            AlertHelpers.showAlert('Made invoices')
        },

        requestValidationMultiple() {
            this.invoicesNeedingValidation.forEach(invoice => {
                this.requestValidation(invoice)
            })
        },
        sendInvoiceMultiple() {
            this.invoicesReadyToSend.forEach(invoice => {
                this.sendInvoice(invoice)
            })
        },


        // Previous

        async deleteCharge(charge) {
            let amountString = StringHelpers.formatCurrency(charge.amount)
            if(this.mine) {
                AlertHelpers.showAlert('You cannot delete your own charges, you sneaky thing')
                return
            }

            if(await this.$root.$confirm('Delete', `Are you sure you want to delete this charge for ${charge.client} amounting to ${amountString} from the invoice?`, { color: 'red' }) == true) {
                console.log('deleting charge', charge.meta.key)
                NiceData.deleteItem(charge)
                charge.amount = 0
                charge.clients = '*** Deleted ***'
            }
        },
        async deleteInvoice(invoice) {
            if(await this.$root.$confirm('Delete', `Are you sure you want to delete this invoice?`, { color: 'red' }) == true) {
                console.log('deleting invoice', invoice)
                NiceData.deleteItem(invoice)
                this.loadInvoices()
            }
        },

        getProcessorForContact (contact) {
            let processors = LookupData.processors()
            let processor = processors.find(p => p.uid == contact.uid ||  p.email == contact.email)
            if(processor)
                return processor
            else
                return {}
        },

        async emailAllInvoicesToBookkeeper() {
            const template = await this.getTemplate('Send Invoices to Bookkeeper')
            let invoiceSummary = ""

            this.insightInvoicesSent.forEach(invoice => {
                invoiceSummary += invoice.html + "<hr/>"
            })
            const to = 'accounting@insightprocessing.com.au'
            const cc = 'billing@insightprocessing.com.au'

            this.emailInvoice(template, invoiceSummary, 'Emma', to, cc, invoice)
        },

        getBillingEmail(email) {
            return new Promise( (resolve, reject) => {
                ContactHelpers.fetchContactByEmail(email).then(contact => {

                    const uid = contact.meta.key
                    const tenantKey = DataHelpers.getTenantKey()
                    let ref = DataHelpers.getRootRef().child(`users/${uid}/offices/${tenantKey}/preferences/email/billing`)
                    NiceData.fetchValue(ref).then(billingEmail => {

                        if(!billingEmail)
                            billingEmail = email
                        resolve(billingEmail)
                    })
                }).catch(err => {
                    console.log('getBillingEmail threw an error so just used normal email address', err)
                    resolve(email)
                })
            })
        },

        emailInvoice(template, invoiceHtml, greeting, to, cc, invoice) {

            // invoice.html was coming through blank. changing to get it manually from dom...

            if(!invoiceHtml) {
                const el = document.getElementById('invoice' + invoice.meta.key)
                if(el && el.innerHTML)
                    invoiceHtml = el.innerHTML
                else {
                    AlertHelpers.showAlert('Cant get invoice info. Not sent.')
                    return
                }
            }


            console.log('*** sending invoice ***', to, cc,)

            let customFields = {
                greeting,
                sender: this.$store.getters.user.firstName,
                invoice: invoiceHtml,
            }

            if(invoice)
                customFields.pdf = EmailHelpers.emailButton(`invoice/${this.month}/${invoice.meta.key}`, 'Get PDF Version')

            let body = MergeHelpers.simpleMerge(template.body, customFields)

            let email = {}
            email.to = [{email: to}]
            email.cc = [{email: cc}]
            email.subject = template.subject || ''
            email.body = body

            //if(this.currentUser.email == email.to)
                email.from = 'no-reply@insightprocessing.com.au'

            email.bcc = [{email:  DataHelpers.getUserEmail() }]

            //August 2022 Changed to use smtp2go, as old emails were being blocked by smtp server.
            //to, cc and bcc were changed to arrays of objects (originally strings)

            const logId = EmailHelpers.queueEmail( email )
            this.$root.$monitorMail(logId)

            // EmailHelpers.sendEmail(email).then(msg => {
            //     if(msg != 'OK')
            //         AlertHelpers.showAlert('Email Failed - ' + msg)
            //     else
            //         AlertHelpers.showAlert('Email Sent to ' + greeting)
            // })


        },
        showCharge(invoice) {
            let user = invoice.to

            this.chargeDialog.charge.date = (
                this.viewingCurrentMonth ? DateHelpers.todayString() : this.month + '-01'
            )

            this.chargeDialog.charge.from = DataHelpers.getUser()
            this.chargeDialog.description = ''
            this.chargeDialog.clients = ''
            this.chargeDialog.charge.to = user
            this.chargeDialog.amount = 0
            this.chargeDialog.settings.visible = true
        },

    },

    watch: {
        'month': {
            immediate: false,
            handler: function(newVal) {
                this.loadInvoices()
            }
        },
    },

    created() {
        DataHelpers.fetchUser().then(user => {
            this.user = user
            this.loadInvoices()
        })
    }

}
</script>

<style>

    .invoice {
        position:relative;
        border: solid 1px #ccc;
        opacity: 1;
    }

    @media print {
        .invoice {
            page-break-after: always;
            border:none!important;
            display:block!important;
        }
        invoice:last-of-type {
            page-break-after:none;
        }
    }

    .big-number {
        font-size:40px;
        margin:10px;
        border-radius:10px;
    }
    .invoice-hoverable:hover {
        border: solid 1px steelblue!important;
    }

    .flex-row {
        display:flex;
        width:100%
    }
    .flex-col-sm {
        flex-basis: 48px;
    }
    .flex-col-grow {
        flex-grow: 1
    }
</style>




// WEBPACK FOOTER //
// Billing.vue?386be740